import type { Messages } from '../index';
import { common } from './common';
import { components } from './components';
import { documents } from './documents';
import { emails } from './emails';
import { errors } from './errors';
import { notices } from './notices';
import { pages } from './pages';
import { permissions } from './permissions';
import { portal } from './portal';

/**
 * en-US dictionary. Typed `Messages` (= `typeof de`), so any missing or
 * differently-shaped key vs the canonical German source is a compile error.
 */
export const en: Messages = { common, components, documents, emails, errors, notices, pages, permissions, portal };
